import { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

const UpdateIsNfp = ({ categories }) => {
    const {
        initialValues,
        setFieldValue,
        values: { Category = [], Is_Nfp, Managed_By_Primary },
    } = useFormikContext();

    useEffect(() => {
        const hasSelectedCategory = !!(
            Category &&
            Category[0] &&
            Category[0].length > 0
        );
        const hasIsNfpBeenModified = initialValues.Is_Nfp !== Is_Nfp;
        const category = categories.find(({ id }) => `${id}` === Category[0]);
        if (category) {
            const { attachFundraising, attachNonfundraising } = category;
            if (!attachFundraising && attachNonfundraising) {
                setFieldValue("Is_Nfp", true);
            } else if (attachFundraising && !attachNonfundraising) {
                setFieldValue("Is_Nfp", false);
            } else {
                setFieldValue("Is_Nfp", Is_Nfp);
            }
        } else if (!hasSelectedCategory && hasIsNfpBeenModified) {
            // If no Category is selected but Is_Nfp has been modified it means
            // that the fundraising status (FP or NFP) was modified when the
            // user was registering the participant for a different category.
            // Reverting the fundraising status to its original state allows
            // users to see the full list of fundraising options available when
            // they select a new Category.
            setFieldValue("Is_Nfp", initialValues.Is_Nfp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Category]);

    // Managed Accounts use their parent's email. We need to prevent saving a unique
    // email address for managed accounts
    useEffect(() => {
        if (Managed_By_Primary) {
            setFieldValue("Email", "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Managed_By_Primary]);

    return null;
};

UpdateIsNfp.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default UpdateIsNfp;
